import { render, staticRenderFns } from "./MediaObjectEditForm.vue?vue&type=template&id=b736f5f4&"
import script from "./MediaObjectEditForm.vue?vue&type=script&lang=ts&"
export * from "./MediaObjectEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports